<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import ViewerPill from '@/components/bop/ViewerPill.vue'

defineProps<{
  articleNumber: string
  required: number
  total: number
}>()

const emit = defineEmits<{
  pick: []
}>()

const { t } = useI18n()
</script>

<template>
  <viewer-pill floating class="viewer-instance-prompt">
    <v-icon size="18" color="warning" class="viewer-instance-prompt__icon">touch_app</v-icon>
    <span class="viewer-instance-prompt__label">
      {{
        t('component.bopModelViewer.instanceSelectionPrompt', {
          required,
          total,
          article: articleNumber,
        })
      }}
    </span>
    <v-btn
      size="small"
      variant="flat"
      color="primary"
      prepend-icon="touch_app"
      @click="emit('pick')"
    >
      {{ t('component.bopModelViewer.selectInstances') }}
    </v-btn>
  </viewer-pill>
</template>

<style scoped>
.viewer-instance-prompt__label {
  max-width: 320px;
  font-size: 0.8em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
}

.viewer-instance-prompt {
  animation: viewer-prompt-arrive 420ms cubic-bezier(0.16, 1, 0.3, 1) both;
}

.viewer-instance-prompt::before {
  animation: viewer-prompt-settle 900ms cubic-bezier(0.16, 1, 0.3, 1) 180ms both;
}

.viewer-instance-prompt.viewer-bar-leave-active {
  animation: viewer-prompt-depart 200ms cubic-bezier(0.7, 0, 0.84, 0) both;
}

.viewer-instance-prompt__icon {
  animation: viewer-prompt-tap 520ms cubic-bezier(0.16, 1, 0.3, 1) 420ms both;
}

@keyframes viewer-prompt-arrive {
  from {
    opacity: 0;
    transform: translateY(-14px);
    filter: blur(4px);
  }
  to {
    opacity: 1;
    transform: none;
    filter: none;
  }
}

@keyframes viewer-prompt-depart {
  from {
    opacity: 1;
    transform: none;
    filter: none;
  }
  to {
    opacity: 0;
    transform: translateY(-10px);
    filter: blur(3px);
  }
}

@keyframes viewer-prompt-settle {
  from {
    box-shadow: 0 6px 20px rgba(var(--v-theme-warning), 0.45);
  }
  to {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
}

@keyframes viewer-prompt-tap {
  0%,
  100% {
    transform: scale(1);
  }
  35% {
    transform: translateY(1px) scale(0.78);
  }
  65% {
    transform: scale(1.08);
  }
}

@media (prefers-reduced-motion: reduce) {
  .viewer-instance-prompt,
  .viewer-instance-prompt::before,
  .viewer-instance-prompt.viewer-bar-leave-active,
  .viewer-instance-prompt__icon {
    animation: none;
  }
}
</style>
